const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 4.364a1.09 1.09 0 0 0-1.09 1.09V12a1.09 1.09 0 0 0 .602.976l4.364 2.182a1.09 1.09 0 0 0 1.463-.488 1.09 1.09 0 0 0-.487-1.464l-3.761-1.88V5.456A1.09 1.09 0 0 0 12 4.364"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 0C5.386 0 0 5.386 0 12s5.386 12 12 12 12-5.386 12-12S18.614 0 12 0m0 2.182A9.8 9.8 0 0 1 21.818 12 9.8 9.8 0 0 1 12 21.818 9.8 9.8 0 0 1 2.182 12 9.8 9.8 0 0 1 12 2.182"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
